import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useHiringStatus() {
  const { data: isHiring = false, isLoading } = useQuery({
    queryKey: ["hiring-status"],
    queryFn: async () => {
      const { data } = await supabase
        .from("site_settings" as any)
        .select("value")
        .eq("key", "hiring_active")
        .single();
      return (data as any)?.value === "true";
    },
    staleTime: 60_000,
  });

  return { isHiring, isLoading };
}
